import { isManagement, isOperatorAdmin } from "./auth";

export const ROLE_MANAGEMENT = "management";
export const ROLE_OPERATOR_ADMIN = "operator_admin";
export const ROLE_OPERATOR = "operator";

export const MENU_TREE = [
    { type: "link", route: "bookings", label: "Bookings" },
    { type: "link", route: "create-booking", label: "Create Booking" },
    { type: "link", route: "dashboard", label: "Dashboard" },
    {
        type: "group",
        id: "location",
        label: "Location",
        children: [
            { route: "contacts", label: "Contacts" },
            { route: "opening-hours", label: "Opening hours" },
            {
                route: "location",
                label: "Users",
                roles: [ROLE_MANAGEMENT, ROLE_OPERATOR_ADMIN],
            },
        ],
    },
    {
        type: "group",
        id: "information",
        label: "Information",
        children: [
            { route: "general-information", label: "General Information" },
            { route: "site-information", label: "Site Information" },
        ],
    },
    {
        type: "group",
        id: "xcube-admin",
        label: "X-Cube Admin",
        roles: [ROLE_MANAGEMENT],
        children: [
            { route: "applications", label: "Applications" },
            { route: "experiences", label: "Experiences" },
            { route: "xcube-control", label: "X-Cube-Control" },
            { route: "tools", label: "Tools" },
        ],
    },
];

export const roleFromUser = (user) => {
    if (isManagement(user)) {
        return ROLE_MANAGEMENT;
    }
    if (isOperatorAdmin(user)) {
        return ROLE_OPERATOR_ADMIN;
    }
    return ROLE_OPERATOR;
};

const allowedForRole = (item, role) => !item.roles || item.roles.includes(role);

export const menuForRole = (role) => MENU_TREE.flatMap((item) => {
    if (!allowedForRole(item, role)) {
        return [];
    }
    if (item.type !== "group") {
        return [item];
    }
    const children = item.children.filter((child) => allowedForRole(child, role));
    if (children.length === 0) {
        return [];
    }
    return [{ ...item, children }];
});

export const groupContainsRoute = (group, routeName) => (
    group.children.some((child) => child.route === routeName)
);
